// v3.15-1002: WorkspaceRoute — hard route guard for the internal workspace
// surface (Dashboard / Calendar / Availability). External partners and VO
// officers can still hold a session and use the rest of the app, but they
// MUST NOT see these areas. A direct URL hit silently redirects them to
// /clients (their assigned-deals worldview). No 403 page — they should feel
// like they're inside their own workspace, not blocked from a bigger one.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const WorkspaceRoute = ({ children }) => {
  const { canAccessWorkspace, user, loading, authChecked } = useAuth();

  // Wait for auth bootstrap so we don't redirect on the first paint while
  // the user object is still hydrating.
  if (loading || (!user && !authChecked)) return null;

  if (!canAccessWorkspace()) {
    return <Navigate to="/clients" replace />;
  }
  return children;
};

export default WorkspaceRoute;
